module.exports = __webpack_public_path__ + "img/gouxuan@3x.75533cb1.svg";